import React from 'react';

import BaseLayout from 'apps/auth/components/common/Layout/BaseLayout';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import { AUTH_PROFILE_AML_LEVEL, AUTH_PROFILE_LIMITS } from 'apps/auth/constants/UrlConstants';
import { resolveArguments } from 'apps/auth/helpers/utils';

const UsaCheckPersonalDetails = (props) => {
    return (
        <BaseLayout showChat={false}>
            <InfoPage
                iconName="id-card-80"
                iconColor="primary"
                headerText={
                    <>
                        <span className="color-GT">{resolveArguments(props.profilePurpleBlock, props.aml_level_name)}</span>&nbsp;
                        {props.personalDetailsBlock}
                    </>
                }
                secondaryText={props.increase_sub_block}
                topButtonCaption={props.notNowButton}
                topButtonType="link"
                topButtonLink={AUTH_PROFILE_LIMITS}
                topButtonOnClick={(e) => {
                    if (props.onClickNotNow) {
                        e.preventDefault();
                        props.onClickNotNow();
                    }
                }}
                primaryButtonCaption={props.nextButton}
                primaryButtonType="link"
                primaryButtonLink={`${AUTH_PROFILE_AML_LEVEL}/${props.currentLevel + 1}/docs`}
                primaryButtonOnClick={(e) => {
                    if (props.onClickContinue) {
                        e.preventDefault();
                        props.onClickContinue();
                    }
                }}
            />
        </BaseLayout>
    );
};

export default UsaCheckPersonalDetails;
